import { render } from "./WithdrawalRecords.vue?vue&type=template&id=d4f74d92&scoped=true"
import script from "./WithdrawalRecords.vue?vue&type=script&lang=js"
export * from "./WithdrawalRecords.vue?vue&type=script&lang=js"

import "./WithdrawalRecords.vue?vue&type=style&index=0&id=d4f74d92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4f74d92"]])

export default __exports__